export const LanguageConfig= {
	'animalForm.name.label':"Enter your animal's name",
	'animalForm.name.labelCommunity':"Enter the animal's name",
	'animalForm.Change.label':"Change",
	'animalForm.Remove.label':"Remove Animal",
	'animalForm.a_source.label':"This animal is ...",
	'animalForm.a_color_primary.label':"Primary color.",
	'animalForm.a_color_secondary.label':"Secondary color",
	'animalForm.a_weight.label':"Weight",
	'animalForm.is_microchipped.label':"Has microchip",
	'animalForm.was_pregnant.label':"Has recently had a litter",
	'animalForm.is_pregnant.label':"Is pregnant",
	
	StaffSponsorCodes_SponsorName:"Sponsor name",
	StaffSponsorCodes_SponsorProgram:"Sponsor program name",
	StaffSponsorCodes_SponsorAddNew:"Add new sponsor program",
	StaffSponsorCodes_SponsorCost:"Applicant cost",
	StaffSponsorCodes_SponsorMaxSpent:"Max spend",
	StaffSponsorCodes_SponsorEmailText:"Email text",
	
	StaffSponsorCodes_ShowInactive:"Show inactive",
	StaffSponsorCodes_ShowArchived:"Show archived",
	
}